import React from "react";
import { Card } from "primereact/card"
import DocumentoCard from "./DocumentoCard"
import { Dashboard } from "../Dashboard"
import { dashboardStyles } from "../DashboardWrapper.css";
import CardsWelcome from "./CardsWelcome";
import ReferencesContainer from "./ReferencesContainer";
import CreditrustPanel from "./CreditrustPanel";
import { Chip } from 'primereact/chip';

export default function ContenidoPrincipal({
  categoriaSeleccionada,
  onVerDocumento,
  onDescargarDocumento,
  persona,
  people,
  setPeople,
  currentUser,
  dataBuro,
  setDataBuro,
  setLoading,
  loading,
  toast,
  onChangePersonFetch,
  setSelectedPersonDirect,
  selectedPerson,
  categories,
  loadingFiles,
  buroDataCache,
}) {
  // Si la categoría es BURO, mostrar el Dashboard
  if (categoriaSeleccionada === "BURO" || categoriaSeleccionada === "BURO DE CREDITO") {


    return (
      <Dashboard
        dataBuro={dataBuro}
        setDataBuro={setDataBuro}
        setLoading={setLoading}
        loading={loading}
        toast={toast}
        setSelectedPerson={onChangePersonFetch}
        selectedPerson={selectedPerson}
        people={people}
        setPeople={setPeople}
        currentUser={currentUser}
        buroDataCache={buroDataCache}
      />
    );
  }

  const renderContenido = () => {
    if (categoriaSeleccionada === "INICIO" || categoriaSeleccionada === "COTIZACION") {
      return (
        <CardsWelcome persona={persona} setSelectedPerson={onChangePersonFetch} setSelectedPersonDirect={setSelectedPersonDirect} toast={toast} setLoading={setLoading} />
      )
    }
    if (categoriaSeleccionada === "REFERENCIAS") {
      const referencias = categories?.REFERENCES || [];
      return <ReferencesContainer references={referencias} />;
    }
    if (categoriaSeleccionada === "CREDITRUST") {
      return <CreditrustPanel persona={persona} toast={toast} />;
    }


    // ✅ Si está cargando, mostrar skeletons
    if (loadingFiles) {
      return (
        <div className="grid ">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="col-12 lg:col-6 2">
              <DocumentoCard
                key={index}
                documento={null}
                loadingFiles={true}
                onVerDocumento={onVerDocumento}
                onDescargarDocumento={onDescargarDocumento}
              />


            </div>
          ))}
        </div>
      );
    }

    // ✅ Mostrar documentos de la categoría seleccionada
    if (categories && categories[categoriaSeleccionada]) {
      const documentos = categories[categoriaSeleccionada];

      return (
        <div className="grid">
          {documentos.map((doc, index) => (
            <div key={index} className="col-12 lg:col-6 2">
              <DocumentoCard
                key={index}
                documento={doc}
                loadingFiles={false}
                onVerDocumento={onVerDocumento}
                onDescargarDocumento={onDescargarDocumento}
              />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="text-500 text-center py-6">
        <i className="pi pi-file text-4xl mb-2" />
        <p className="m-0">No hay documentos disponibles para {categoriaSeleccionada}</p>
      </div>
    )
  }


  return (
    <div className="flex-1 render-content" css={dashboardStyles()}>
      <Card
        title={
          <div className="flex align-items-center gap-2">

            <i className="pi pi-file"></i>
            <span>{categoriaSeleccionada}</span>
          </div>
        }
      >
        {(() => {
          if (!persona?.infoBudget) return null;

          const { vehicle, price, term, monthly_rent, residual_value_id } = persona.infoBudget;
          const typeLabel = residual_value_id === null ? 'Cotización Financiera' : 'Puro';
          const currency = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2, maximumFractionDigits: 2 });

          // Helper to style chips with pastel colors
          const chipStyle = (bgColor, borderColor) => ({
            backgroundColor: bgColor,
            borderColor: borderColor,
            height: '24px'
          });

          return (
            <div className="flex flex-wrap gap-2 mb-3">
              <Chip
                label={typeLabel}
                icon="pi pi-wallet mr-2"
                className="text-900 text-xs font-medium border-1 py-0 mix-blend-multiply"
                style={chipStyle('#E3F2FD', '#BBDEFB')} // Pastel Blue
              />
              {vehicle && (
                <Chip
                  label={`${vehicle.brand} ${vehicle.model} ${vehicle.year}`}
                  icon="pi pi-car mr-2"
                  className="text-900 text-xs font-medium border-1 py-0"
                  style={chipStyle('#F3E5F5', '#E1BEE7')} // Pastel Purple
                />
              )}
              <Chip
                label={`Precio: ${currency.format(price)}`}
                icon="pi pi-tag mr-2"
                className="text-900 text-xs font-medium border-1 py-0"
                style={chipStyle('#E8F5E9', '#C8E6C9')} // Pastel Green
              />
              <Chip
                label={`Plazo: ${term}m`}
                icon="pi pi-calendar mr-2"
                className="text-900 text-xs font-medium border-1 py-0"
                style={chipStyle('#FFF3E0', '#FFE0B2')} // Pastel Orange
              />
              {monthly_rent && (
                <Chip
                  label={`Mensual: ${currency.format(residual_value_id === null ? monthly_rent : monthly_rent * 1.16)}`}
                  icon="pi pi-money-bill mr-2"
                  className="text-900 text-xs font-medium border-1 py-0"
                  style={chipStyle('#FFEBEE', '#FFCDD2')} // Pastel Red
                />
              )}
            </div>
          )
        })()}

        {
          renderContenido()
        }
      </Card>
    </div>
  )
} 